/**
 * Every word on the worker page and the Shade photos panel, in one place so a Hindi version can be added later
 * without touching the components.
 */
export const SHADE_STRINGS = {
  brand: "HastKala Pramanak",
  eyebrow: "Shade photos",
  opening: "Opening this link…",
  serial: (n: string) => `#${n}`,
  dyedColour: (c: string) => `Dyed colour: ${c}`,
  colour: (c: string) => `Colour: ${c}`,
  takePhoto: "Take photo",
  chooseGallery: "Choose from gallery",
  counter: (used: number, max: number, left: number) => `${used} of ${max} · ${left} left`,
  hint: "Take the whole piece in daylight. Photos go to the studio owner, not to buyers.",
  sending: "Sending…",
  waiting: "Waiting for a connection",
  sent: "Sent",
  failed: "Not sent",
  retry: "Retry",
  remove: "Remove",
  doneTitle: (n: number) => `${n} ${n === 1 ? "photo" : "photos"} sent. The owner will check them.`,
  addMore: "Add more",
  offline: "No connection. Photos are kept on this phone and sent when you are back online.",
  tooMany: (left: number) => (left > 0 ? `Only ${left} more ${left === 1 ? "photo" : "photos"} can be sent on this link.` : "No more photos can be sent on this link."),
  rejectedType: "This file is not a photo we can use. Send a JPEG or PNG photo.",
  rejectedSize: "This photo is over 15 MB. Send a smaller one.",
  rejectedPrepare: "This photo could not be prepared on this phone. Try another one.",
  closed: {
    EXPIRED: { title: "This link has expired", body: "Ask the studio for a new link." },
    REVOKED: { title: "The studio closed this link", body: "Ask the studio if they still need photos." },
    LINK_FULL: { title: "20 photos sent, that is the limit", body: "Thank you. Ask the studio for a new link if you have more." },
    NOT_VALID: { title: "This link is not valid", body: "Check you opened the whole link, or ask the studio for a new one." },
    UNAVAILABLE: { title: "Photos can't be sent right now", body: "Try again in a few minutes." },
  } as Record<string, { title: string; body: string }>,
  tryAgain: "Try again",

  // Studio panel
  panelTitle: "Shade photos",
  panelHint: "Main photos stay as they are until you choose Use as main photo.",
  pending: (n: number) => `Waiting for review (${n})`,
  approved: (n: number) => `Approved (${n})`,
  rejected: (n: number) => `${n} rejected`,
  hideRejected: "Hide rejected",
  approve: "Approve",
  reject: "Reject",
  useAsMain: "Use as main photo",
  isMain: "Main photo",
  primary: "Catalogue cover",
  waitingAdmin: "Waiting for admin approval",
  copiesPending: "Preparing…",
  sentBy: (who: string | null | undefined, when: string) => (who ? `${who} · ${when}` : when),
  confirmTitle: "Use as main photo?",
  confirmBody: "This photo becomes the first main photo buyers see. The current main photos stay.",
  confirm: "Use as main photo",
  cancel: "Cancel",
  close: "Close",
  zoom: "Zoom",
  previous: "Previous photo",
  next: "Next photo",
  newMain: "Done. It is now the first main photo.",

  // Link sheet
  getLink: "Get upload link",
  reviewPhotos: "Review photos",
  linkTitle: "Upload link for a worker",
  linkBody: (hours: number, max: number) => `Works for ${hours} hours, up to ${max} photos of this piece. Send it only to the person taking the photos.`,
  copy: "Copy link",
  copied: "Copied",
  share: "Share",
  linkExpires: (when: string) => `Expires ${when}`,
  openLinks: (n: number) => `${n} open ${n === 1 ? "link" : "links"}`,
  closeLink: "Close link",
  making: "Making a link…",
  error: "Could not complete that. Try again.",
  noConnection: "No connection. Try again.",
};
